/**
 * LinkTabContent
 * Invite Link tab for GroupInvitationModal. Uses parent-provided link state so the link is only generated when first entering the tab.
 */

import { InviteLinkContent } from '../../shared/InviteLinkContent/InviteLinkContent';
import { DEEP_LINK_TYPES } from '../../../src/shared/types/deepLink.types';
import type { InviteLinkState } from '../../shared/InviteLinkContent/InviteLinkContent';

export interface LinkTabContentProps {
  groupId: string;
  linkState: InviteLinkState;
}

export function LinkTabContent({ groupId, linkState }: LinkTabContentProps) {
  return (
    <InviteLinkContent
      type={DEEP_LINK_TYPES.GROUP}
      targetId={groupId}
      description="Share this link to invite people to your group"
      linkState={linkState}
    />
  );
}
